import {defineAsyncComponent} from 'vue';

// màn detail
const InitialBalanceDetailPopup = defineAsyncComponent(() =>
  import('@/views/initialBalance/detail/InitialBalanceDetailPopup.vue'),
);

export function registerInitialBalance(app) {
    app.component('InitialBalanceDetailPopup', InitialBalanceDetailPopup);
}
